import React, { useState } from "react";
import { RxPencil1 } from "react-icons/rx";
import { Link } from "react-router-dom";
import { MdAdd, MdOrderingWatermark, MdLocationCity, MdOutlineDelete, MdOutlineGroup, MdRemoveRedEye } from "react-icons/md";
import { observer } from "mobx-react";
import Filter from "./OrderFilter/Filter"
import ReactPaginate from 'react-paginate';
import { OrderStore, useOrderStore, OrderStoreContext } from "./store/Orderstore";
import { useAuthStore } from "../Auth/store/Auth";
import { useEffect } from "react";
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";
import { toast, ToastContainer } from "react-toastify";
import Moment from "react-moment";

const ReturnManagement = () => {
    const store = new OrderStore({
        isReturn: true,
        editloading: false
    });
    return (
        <OrderStoreContext.Provider value={store}>
            <Screen />
        </OrderStoreContext.Provider>
    )
}
export default ReturnManagement;


const Screen = observer(() => {
    const {
        ReturnOrder,
        loadcity,
        OrderStatusLoader,
        Rejected_status_Change,
        nolist,
        Citypopup,
        BulkDelete,
        BulkstatusChange,
        OrderLoader,
        // setallOrder,
        // allOrder,
        getReturnProductList,
        Return_status_Change,
        Order_status_Change,
        setPaginationPage,
        setalldeactivate,
        alldeactivate,
        getOrderList,
        getFilterOrder,
        TotalPages,
        setOrderpopup,
        Orderpopup,
        deletepopup,
        dimensionspopup,
        setdeletepopup,
        setdimensionspopup,
        setdelateLoader,
        delateLoader,
        statusChange,
        setstatuspopup,
        getid,
        getstatus,
        deletefunction,
        setchecked,
        checkeddd,
        order_status,
        getToken
    } = useOrderStore();

    const { adminAuthApproved, admin_permissions } = useAuthStore();
    const [weight, setWeight] = useState('');
    const [breadth, setBreadth] = useState('');
    const [height, setHeight] = useState('');
    const [length, setLength] = useState('');

    const [reason, setreason] = useState('');

    useEffect(() => {
        if (adminAuthApproved) {
            getToken(localStorage.getItem("Admintoken"));
        }

    }, [adminAuthApproved]);

    const [currentPage, setCurrentPage] = useState(0);
    const [reasonPopup, setreasonPopup] = useState(false);
    const [orderid, getorderid] = useState(null);
    const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
    const [allOrder, setallOrder] = useState([])
    // const [checkeddd, setchecked] = useState(false)

    const [photoIndex, setPhotoIndex] = useState("");
    const ITEMS_PER_PAGE = 10;
    const handlePageChange = ({ selected }) => {
        setPaginationPage(selected + 1);
        // getFilterOrder();
        getReturnProductList();
        setCurrentPage(selected);
    };

    const handleClick = () => {
        const element = document.getElementById("tablescroll");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
    const startIndex = currentPage * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const Orders = ReturnOrder?.slice(startIndex, endIndex);
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const openLightbox = (index) => {
        setLightboxIsOpen(true);
    };

    const closeLightbox = () => {
        setLightboxIsOpen(false);
    };

    const checkAllCheckboxes = () => {
        setallOrder([]);
        // Get all checkboxes with the same name attribute
        var checkboxes = document.getElementsByName('myCheckbox');

        if (checkeddd) {
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;
            }
            setallOrder([]);
        } else {
            var emails = [];
            var commaSeparatedEmails = [];
            // var emailArray = emailString.split(",").map((email) => email.trim());
            // Loop through each checkbox and check it
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = true;
                var emailValues = checkboxes[i].value.split(',');
                if (emailValues.length > 1) {
                    commaSeparatedEmails.push(...emailValues);
                } else {
                    var emailValue = emailValues[0].trim();
                    if (emailValue !== '' && !emails.includes(emailValue)) {
                        emails.push(emailValue);
                    }

                }
            }
            setallOrder((prevEmails) => [...prevEmails, ...emails, ...commaSeparatedEmails]);
        }

    }
    const isallcheck = (e) => {
        var checkboxes = document.getElementsByName('myCheckbox');
        for (var i = 0; i < checkboxes.length; i++) {
            var updatedEmails = Array.from(checkboxes)
                .filter((checkbox) => checkbox.checked)
                .flatMap((checkbox) => checkbox.value.split(',').map((email) => email.trim()));
            setallOrder(updatedEmails);
            if (!checkboxes[i].checked) {
                setchecked(false)
                return
            }
            else {
                setchecked(true)
            }

        }
    }
    const handleSelectChange = (e, id) => {
        const selectedValue = e.target.value;
        // getorderid(id)// Convert the value to an integer if necessary
        if (selectedValue == "Return Approved") {
            setdimensionspopup(true);
            getorderid(id)
        }
        else if (selectedValue == "Return Rejected") {
            setreasonPopup(true);
            getorderid(id)
          
        }
    };
    const deleteFunction = () => {
        // Your delete function logic here
        // console.log('Delete function triggered for option:', selectedOption);
        setdimensionspopup(false); // Close the modal after deletion
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log('Form submitted with values:', { weight, breadth, height, length });
        Return_status_Change(2, orderid, weight, breadth, height, length);
        if (OrderStatusLoader) {
            setWeight("");
            setBreadth("");
            setHeight("");
            setLength("");
        }
    };
    const handleSubmitReason = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log('Form submitted with values:', { weight, breadth, height, length });
        Rejected_status_Change("Return Rejected", orderid , reason);

        if (OrderStatusLoader) {
     setreason("")
     
        }
        else{
            setreasonPopup(false)
        }
    };
    console.log(ReturnOrder);
    return (
        <>
            <div className="flex justify-between mt-[51px] ">
                <div className=" mb-4">
                    <p className=" text-2xl font-semibold">Return Order</p>
                    <p className=" opacity-80 text-sm">Home /Return Order</p>
                </div>

            </div>

            {/* <Filter /> */}

          


            <div className="card bg-base-100 shadow-md p-6 mt-8">
                <div className="overflow-x-auto w-full">
                    <table id="tablescroll" className="table table-zebra w-full">
                        <thead>
                            <tr>
                                {/* <th></th> */}
                                <th>Return ID</th>
                                <th>Order ID</th>
                                <th>Buyer</th>
                                <th>Order's Date & Time</th>
                                <th>Amount</th>
                                <th>Order status</th>
                                <th>Payment type</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody className="text-sm relative">
                            {OrderLoader &&
                                <>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={8} className="animate-pulse py-6"></td>
                                    </tr>
                                </>
                            }
                            {
                                (Orders.length === 0 ? ReturnOrder : Orders)?.map((data, index) => (
                                    <tr key={index} className="capitalize">
                                        {/* <td>

                                            <input
                                                value={data?.id}
                                                onChange={(e) => { setchecked(false); isallcheck(e.target.value); }}
                                                type="checkbox"
                                                name="myCheckbox"
                                            />
                                        </td> */}
                                            <td>
                                            {data?.modified_return_id}
                                        </td>
                                        <td>
                                            {data?.order_id}
                                        </td>

                                    

                                        <td className="flex flex-col ">
                                            <div>
                                                {data?.buyer_fullname ?? "N/A"}

                                            </div>
                                            {/* <div>
                                                {data?.buyer_email ?? "N/A"}

                                            </div> */}

                                        </td>
                                        <td>
                                            <Moment
                                                format={
                                                    "DD/MM/YYYY"
                                                }
                                            >
                                                {data.created_at}
                                            </Moment>

                                        </td>

                                        <td>
                                            {data.total_amount}

                                        </td>

                                        <td>
                                            {data.order_status != "Cancelled" ?
                                                OrderStatusLoader ?
                                                    <>
                                                        <svg
                                                            className="animate-spin  mr-5  mt-[5%] h-[3%] w-[23%] text-color_theme"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <circle
                                                                className="opacity-25"
                                                                cx="12"
                                                                cy="12"
                                                                r="10"
                                                                stroke="currentColor"
                                                                strokeWidth="4"
                                                            ></circle>
                                                            <path
                                                                className="opacity-75"
                                                                fill="currentColor"
                                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            ></path>
                                                        </svg>
                                                    </> :


                                                    data?.status_name == "Return Approved" || data?.status_name == "Return Rejected" ?
                                                    data?.status_name
                                                        :
                                                        <select
                                                        className="select status focus:outline-0 text-sm font-medium rounded-md select-bordered"
                                                        onChange={(e) => handleSelectChange(e, data?.return_id)}
                                                        value={data?.status_name}
                                                    >

                                                        <option value="Return">
                                                            Return
                                                        </option>
                                                        <option value="Return Approved">
                                                            Return Approved
                                                        </option>
                                                        <option value="Return Rejected">
                                                            Return Rejected
                                                        </option>


                                                    </select>
                                                    


                                            :
                                            "Cancelled"

                                            }

                                        </td>

                                
                                        <td>
                                            <label
                                                title="Change Status"
                                                htmlFor="my-modal-5"
                                                className={`btn capitalize Active whitespace-nowrap   bg-[#1dc9b7] hover:bg-[#1dc9b7]  text-[#000] border-hidden  btn-xs`}

                                            // onClick={(e) => {
                                            //     getid(data?.id);
                                            //     setProductCatalogpopup(true);
                                            //     getstatus(data?.is_active === 1 ? 0 : 1);
                                            // }}
                                            >
                                                {data?.payment_type ?? "n/a"}
                                            </label>
                                        </td>
                                        <th >
                                            <div className="flex space-x-3">

                                                <div className="flex items-center space-x-3">
                                                    {/* {admin_permissions.Orders === 1 ? */}
                                                    <label
                                                        htmlFor="deletecity"
                                                        className=" text-[#d02c2c] cursor-pointer"
                                                        title="Delete"
                                                        onClick={() => { setdeletepopup(true); getid(data?.order_id) }}
                                                    >
                                                        <MdOutlineDelete />
                                                    </label>
                                                    {/* :
                                                        <label
                                                            htmlFor="deletecity"
                                                            className=" text-[#d02c2c] cursor-pointer"
                                                            title="Delete"
                                                            onClick={() => { toast.warning("You have no permissions to edit.") }}
                                                        >
                                                            <MdOutlineDelete />
                                                        </label> */}
                                                    {/* } */}
                                                    <button title="view product">
                                                        <Link to={`/order/product/${data?.order_id}/${data.total_amount}/${data.return_id}`}>

                                                            <MdRemoveRedEye />

                                                        </Link>
                                                    </button>


                                                </div>
                                            </div>

                                        </th>

                                    </tr>
                                ))
                            }

                            {nolist &&
                                <tr>
                                    <td colSpan={7} className="my-10 text-center">
                                        <MdOutlineGroup className=" text-[#dedede] text-8xl mx-auto" />
                                        <p className=" font-semibold text-lg">No Order Found</p>
                                    </td>
                                </tr>}
                        </tbody>
                    </table>
                    {/* {!city?.length == 0 && */}

                    <ReactPaginate
                        initialPage={0}
                        pageCount={Math.ceil(TotalPages)}
                        pageRangeDisplayed={5}
                        marginPagesDisplayed={2}
                        onPageChange={handlePageChange}
                        onClick={handleClick}
                        containerClassName={'pagination'}
                        activeClassName={'active'}

                    />
                
                    {/* status change model end */}
                    {dimensionspopup && (
                        <>
                            <input type="checkbox" id="deletecity" className="modal-toggle" checked readOnly />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label
                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => setdimensionspopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Enter Dimensions
                                    </h3>
                                    <form onSubmit={handleSubmit} className="mt-4">
                                        <div className="form-control mb-2">
                                            <label className="label">
                                                <span className="label-text">Weight</span>
                                            </label>
                                            <input
                                                type="text"
                                                required

                                                onChange={(e) => setWeight(e.target.value)}
                                                className="input input-bordered w-full"
                                                placeholder="Enter weight"
                                            />
                                        </div>
                                        <div className="form-control mb-2">
                                            <label className="label">
                                                <span className="label-text">Breadth</span>
                                            </label>
                                            <input
                                                type="text"
                                                required

                                                onChange={(e) => setBreadth(e.target.value)}
                                                className="input input-bordered w-full"
                                                placeholder="Enter breadth"
                                            />
                                        </div>
                                        <div className="form-control mb-2">
                                            <label className="label">
                                                <span className="label-text">Height</span>
                                            </label>
                                            <input
                                                type="text"
                                                required

                                                onChange={(e) => setHeight(e.target.value)}
                                                className="input input-bordered w-full"
                                                placeholder="Enter height"
                                            />
                                        </div>
                                        <div className="form-control mb-4">
                                            <label className="label">
                                                <span className="label-text">Length</span>
                                            </label>
                                            <input
                                                type="text"


                                                onChange={(e) => setLength(e.target.value)}
                                                className="input input-bordered w-full"
                                                placeholder="Enter length"
                                            />
                                        </div>
                                        <div className="modal-action justify-center">

                                            {OrderStatusLoader ?
                                                <>
                                                    <button type="button" className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                        Submiting...
                                                        <svg
                                                            className="animate-spin mr-1 h-5 w-5 text-white"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                            <path
                                                                className="opacity-75"
                                                                fill="currentColor"
                                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            ></path>
                                                        </svg>
                                                    </button>
                                                </>
                                                :
                                                <button
                                                    type="submit"
                                                    className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                >
                                                    Submit
                                                </button>
                                            }

                                            <button
                                                type="button"
                                                className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                                onClick={() => setdimensionspopup(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    )}
                      {reasonPopup && (
                        <>
                            <input type="checkbox" id="deletecity" className="modal-toggle" checked readOnly />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label
                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => setreasonPopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Enter Reason
                                    </h3>
                                    <form onSubmit={handleSubmitReason} className="mt-4">
                                        <div className="form-control mb-2">
                                            <label className="label">
                                                <span className="label-text">Reason</span>
                                            </label>
                                            <input
                                                type="text"
                                                required

                                                onChange={(e) => setreason(e.target.value)}
                                                className="input input-bordered w-full"
                                                placeholder="Enter reason"
                                            />
                                        </div>
                                        <div className="modal-action justify-center">

                                            {OrderStatusLoader ?
                                                <>
                                                    <button type="button" className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4">
                                                        Submiting...
                                                        <svg
                                                            className="animate-spin mr-1 h-5 w-5 text-white"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                            <path
                                                                className="opacity-75"
                                                                fill="currentColor"
                                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            ></path>
                                                        </svg>
                                                    </button>
                                                </>
                                                :
                                                <button
                                                    type="submit"
                                                    className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                >
                                                    Submit
                                                </button>
                                            }

                                            <button
                                                type="button"
                                                className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                                onClick={() => setreasonPopup(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    )}
                    {deletepopup &&
                        <>
                            <input type="checkbox" id="deletecity" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => { setdelateLoader(false); setdeletepopup(false) }}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to Delete this Order
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {/* <label
                                            htmlFor="deletecity"
                                            className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                            onClick={() => deletefunction()}
                                        >
                                            Yes
                                        </label> */}
                                        {!delateLoader ?
                                            <label

                                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                onClick={() => deletefunction()}
                                            >
                                                Yes
                                            </label> :
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>}
                                        <label
                                            onClick={() => setdeletepopup(false)}
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>

                    }
                    {Orderpopup &&
                        <>
                            <input type="checkbox" id="my-modal-5" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => setOrderpopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to change Status ?
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {!OrderLoader ? <label

                                            className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                            onClick={() => statusChange()}
                                        >
                                            Yes
                                        </label> :
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>}

                                        <label
                                            onClick={() => setOrderpopup(false)}
                                            // htmlFor="voidstatus"
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                        >
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </>
                    }
                </div>
            </div>

        </>
    );
});

